module.exports = __webpack_public_path__ + "img/tali_wa_gali.60bc1fa3.png";